<template>
  <v-container>
    <div>
      <div>
        <div class="back-nav">
          <v-btn text :to="{ name: 'account', hash: '#owners' }" exact>
            <v-icon left>mdi-chevron-left</v-icon>
            Owner Overview
          </v-btn>
        </div>

        <div class="mb-4">
          <h1 class="page-title">
            <v-icon large color="#3a3a3a">mdi-account-circle-outline</v-icon>
            Account
          </h1>
        </div>
      </div>

      <foldable-card
        non-foldable
        title="Edit Owner Information"
        style="border-top-width: 8px"
      >
        <v-card-actions class="pa-sm-0">
          <v-container class="text-right pa-sm-0 mr-sm-4">
            <v-btn
              v-if="!controls.editMode"
              text
              @click="
                logEvent('Clicked button to edit owner', { Where });
                controls.editMode = !controls.editMode;
              "
              class="edit-button"
              :block="$vuetify.breakpoint.xsOnly"
            >
              <v-icon center small class="edit-button-icon">mdi-pencil</v-icon>
              <span>Edit</span>
            </v-btn>
            <v-btn
              v-if="controls.editMode"
              text
              @click="cancelChanges"
              class="edit-button"
              :block="$vuetify.breakpoint.xsOnly"
            >
              <span>Cancel</span>
            </v-btn>
            <v-btn
              v-if="controls.editMode"
              color="primary"
              class="save-changes-button"
              :block="$vuetify.breakpoint.xsOnly"
              @click="saveChanges"
            >
              Save Changes
            </v-btn>
          </v-container>
        </v-card-actions>
        <v-card-text>
          <v-form>
            <v-container pa-0>
              <v-row no-gutters>
                <v-col cols="12" lg="3">
                  <div class="information-container-title">
                    Is this owner a business?
                  </div>
                </v-col>
                <v-col cols="12" lg="3">
                  <v-checkbox
                    :disabled="!controls.editMode"
                    label="Yes"
                    class="mt-0 pt-0"
                    v-model="vm.thisIsABusiness"
                  />
                </v-col>
              </v-row>
              <v-divider class="my-8"></v-divider>
              <v-row no-gutters v-if="vm.thisIsABusiness">
                <v-col cols="12" lg="3">
                  <div class="information-container-title">
                    Legal Business Name
                  </div>
                </v-col>
                <v-col cols="12" lg="7">
                  <v-text-field
                    filled
                    dense
                    v-model="vm.businessName"
                    label="Company*"
                    :disabled="!controls.editMode"
                    :rules="[rules.required('Company')]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row no-gutters v-if="!vm.thisIsABusiness">
                <v-col cols="12" lg="3">
                  <div class="information-container-title">
                    Owner Information
                  </div>
                </v-col>
                <v-col cols="12" lg="9">
                  <v-row no-gutters>
                    <v-col cols="12" lg="7">
                      <v-text-field
                        filled
                        dense
                        class="first-name"
                        v-model="vm.firstName"
                        label="First Name*"
                        :disabled="!controls.editMode"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="12" lg="7">
                      <v-text-field
                        filled
                        dense
                        v-model="vm.lastName"
                        label="Last Name*"
                        :disabled="!controls.editMode"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="12" lg="7">
                      <date-field
                        v-model="vm.dob"
                        :maxDate="this.getNow()"
                        :label="
                          'Date of Birth' + (controls.dobRequired ? '*' : '')
                        "
                        :rules="[
                          rules.condRequired(
                            'Date of Birth',
                            controls.dobRequired
                          )
                        ]"
                        :disabled="!controls.editMode"
                      >
                      </date-field>
                    </v-col>
                    <v-col cols="12" lg="7">
                      <v-autocomplete
                        :items="['Male', 'Female', 'Unspecified']"
                        filled
                        dense
                        v-model="vm.gender"
                        label="Gender"
                        :disabled="!controls.editMode"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-divider class="my-8"></v-divider>
              <v-row no-gutters>
                <v-col cols="12" lg="3">
                  <div class="information-container-title">
                    Address Information
                  </div>
                </v-col>
                <v-col cols="12" lg="9">
                  <v-row no-gutters>
                    <v-col cols="12" lg="7">
                      <v-text-field
                        filled
                        dense
                        v-model="vm.street1"
                        label="Billing Address 1"
                        :disabled="!controls.editMode"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="12" lg="7">
                      <v-text-field
                        filled
                        dense
                        v-model="vm.street2"
                        label="Suite, APT (optional)"
                        :disabled="!controls.editMode"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="12" sm="8" lg="4">
                      <v-text-field
                        filled
                        dense
                        class="mr-sm-4"
                        v-model="vm.city"
                        label="City"
                        :disabled="!controls.editMode"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4" lg="3">
                      <v-autocomplete
                        filled
                        dense
                        clearable
                        label="State"
                        :items="states"
                        v-model="vm.state"
                        item-value="state"
                        item-text="code"
                        class="state-selector"
                        :disabled="!controls.editMode"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="12" lg="4">
                      <v-text-field
                        filled
                        dense
                        class="mr-lg-4"
                        v-model="vm.postalCode"
                        label="Zip Code"
                        :disabled="!controls.editMode"
                        :rules="[rules.zip]"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-divider class="my-8"></v-divider>
              <v-row no-gutters class="mt-8 mb-2">
                <v-col cols="12" lg="3" md="5">
                  Tax Identification
                </v-col>
                <v-col cols="12" lg="5" md="7">
                  <v-text-field
                    filled
                    dense
                    v-model="vm.taxId"
                    :label="
                      (vm.thisIsABusiness ? 'EIN' : 'SSN') +
                        (controls.tinRequired ? '*' : '')
                    "
                    :rules="[
                      rules.nDigits(vm.thisIsABusiness ? 'EIN' : 'SSN', 9),
                      rules.condRequired(
                        vm.thisIsABusiness ? 'EIN' : 'SSN',
                        controls.tinRequired
                      )
                    ]"
                    :disabled="!controls.editMode"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-divider class="my-8"></v-divider>
              <v-row no-gutters>
                <v-col cols="12" lg="3">
                  <div class="information-container-title">
                    National Provider
                  </div>
                </v-col>
                <v-col cols="12" lg="9">
                  <v-row no-gutters>
                    <v-col cols="12" lg="7">
                      <v-text-field
                        filled
                        dense
                        v-mask="controls.npiMask"
                        v-model="vm.npi"
                        label="National Provider Identifier (NPI)"
                        hint="NPI is a unique ID number for covered healthcare providers."
                        :disabled="!controls.editMode"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-divider class="my-8"></v-divider>
              <v-row no-gutters>
                <v-col cols="12" lg="3">
                  <div class="information-container-title">
                    Ownership
                  </div>
                </v-col>
                <v-col cols="12" lg="4">
                  <v-text-field
                    filled
                    dense
                    class="mr-lg-4"
                    :value="vm.ownershipPercentage"
                    label="Ownership Percentage"
                    :disabled="true"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
      </foldable-card>
    </div>
  </v-container>
</template>

<script>
import FoldableCard from "@/components/FoldableCard";
import { datePickerNow } from "@/services/util";
import DateField from "@/components/DateField";
import * as rules from "@/services/rules";
import { get, put } from "@/services/request";
import { ownerByIdAPI, clientConfigAPI } from "@/services/api";
import { mask } from "vue-the-mask";
import cloneDeep from "lodash/cloneDeep";
import hasConstant from "@/mixins/has-constant";

export default {
  name: "Account",
  mixins: [hasConstant],
  props: ["ownerId", "Where", "clientId"],
  data() {
    return {
      vm: {},
      controls: {
        deleteConfirmationDialogOpen: false,
        npiMask: "##########",
        showSsn: false,
        menu: null,
        editMode: false,
        tinRequired: false,
        dobRequired: false
      },
      rules
    };
  },
  components: {
    "foldable-card": FoldableCard,
    "date-field": DateField
  },
  directives: {
    mask
  },
  created() {
    this.loadData();
  },
  methods: {
    getNow: datePickerNow,
    loadData() {
      get(ownerByIdAPI.getUrl(this.ownerId)).then(response => {
        if (response && response.data) {
          this.vm = response.data;
          this.lastSavedVm = cloneDeep(this.vm);
        }
      });
      if (this.clientId) {
        get(clientConfigAPI.getUrl(this.clientId)).then(response => {
          if (response.data.requirementMap) {
            if (response.data.requirementMap.OWNER_TIN) {
              this.controls.tinRequired =
                response.data.requirementMap.OWNER_TIN;
            }
            if (response.data.requirementMap.OWNER_DOB) {
              this.controls.dobRequired =
                response.data.requirementMap.OWNER_DOB;
            }
          }
        });
      }
    },
    saveChanges() {
      put(ownerByIdAPI.getUrl(this.ownerId), this.vm).then(response => {
        if (response) {
          this.lastSavedVm = cloneDeep(this.vm);
          this.controls.editMode = false;
        }
      });
    },
    cancelChanges() {
      this.vm = cloneDeep(this.lastSavedVm);
      this.controls.editMode = false;
    }
  }
};
</script>

<style lang="sass" scoped></style>
